import { navigateTo, /*context,*/ requestExpandedMode } from '@devvit/web/client';
import { trackEvent } from '../game/analytics';
import { setupAnalyticsConsent } from '../game/analyticsConsent';
import { isEarlyAccessActive } from '../game/earlyAccess';
import { initFeedback } from '../game/feedback';
import { registerPwa } from '../game/pwaRegister';
import { applyTranslations, getLocale, initLocale } from '../game/i18n';

const startButton = document.getElementById('start-button') as HTMLButtonElement;
const daydreamsoftwareLink = document.getElementById('daydreamsoftware-link') as HTMLDivElement;
const splashEarlyAccess = document.getElementById('splash-early-access');

daydreamsoftwareLink.addEventListener('click', () => {
  navigateTo('https://www.daydreamsoftware.es');
});

initLocale();
applyTranslations();
document.documentElement.lang = getLocale();

if (splashEarlyAccess && isEarlyAccessActive()) {
  splashEarlyAccess.classList.remove('hidden');
}

initFeedback(() => ({ screen: 'splash' }));
setupAnalyticsConsent('/splash.html', 'Explowords');
void registerPwa();

startButton.addEventListener('click', (e) => {
  trackEvent('app_start', { from: 'splash' });
  requestExpandedMode(e, 'game');
});
